import React, { useEffect, useState, useContext } from "react";

// Import Swiper React components
import { Swiper, SwiperSlide } from "swiper/react";

// Import react-circular-progressbar module and styles
//https://www.kevinqi.com/react-circular-progressbar/
import { buildStyles, CircularProgressbar } from "react-circular-progressbar";
import "react-circular-progressbar/dist/styles.css";

// Animation
import ChangingProgressProvider from "./ChangingProgressProvider";

//Swiper
import { useQuery } from "react-query";
import { getGlobalSettingValue } from '../../services/common/utils';
// import SwiperCore, {
//   Autoplay,
//   Navigation,
//   Pagination,
//   Virtual,
// } from "swiper/core";
import { Pagination } from 'swiper'; 
import { HOME_DASHBOARD_URL } from "../../services/common/endpoints";
import { GetCacheKey, setItemInSessionStorage, getItemOfSessionStorage } from "../../services/common/utils";
import {
  GetMobileNo,
  TransFormDashboard,
  ConvertFromBytes,
  bytesToTB,
  TransFormDashboardData,
  generateDashboardLayout
} from "../../services/common/CommonUtils";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { Link, useNavigate } from "react-router-dom";
import { setDashboardRecommendations,setdueamount, setNetData, setGTMLoginFlag, setGTMSingUPFlag, setGTMWifiLoginFlag, setLoginType, setNotificationsArray, setShowNotification, setpassportlist, setNewUserProperties } from "../../reducer/actions";
import {GTMScreenView, GTM_Change_Msisdn, GTM_Login, GTM_SignUp} from "../../../src/analytics/GoogleTagManager";
import Loadingcomponent from "../loader/loadingcomponent";
import {UserContext} from '../../pages/home/index';
import { isContainAlphabet  } from "../../services/common/utils";
import {CT_Events} from "../../../src/analytics/CTEvents";
import { SELECTED_LANG } from "../../services/common/Constants";
import Lottie from "lottie-react";
import loader from "../../../src/components/home/viewPacks/Flight";
import lock from "../../../src/Lock.json";
import yellowlock from "../../../src/yellowlocklotteview.json";
import lineexpirylotte from "../../../src/1K9xbLcRXn.json";
import dropdown from "../../../src/drop_down.json";
import dropdownup from "../../../src/drop_up.json";
import UsageList from "./dashboard-comps/usage-list";
import { redirecturl } from '../../services/common/redirect';
// SwiperCore.use([Navigation, Pagination, Autoplay, Virtual]);

// Import Swiper styles
// import 'swiper/swiper-bundle.css';

export const balancekey = "BALANCE_API";
const DashboardComponent = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { t } = useTranslation();
  const logintype = useSelector((state) => state?.userdata?.value?.loginmode);
  const loginmsisdn = useSelector((state) => state?.userdata?.value?.selectedmsisdn);
  const socialLoginType = useSelector((state) => state?.userdata?.value?.socialLoginType);
  const userDetails = useSelector((state)=> state?.userdata?.value?.rnuserdetails);
  const customerprofile = useSelector(
    (state) => state.userdata.value.customerprofile
  );
  const {
    utilityData: { showNotificationAndProfile }
} = useSelector((state) => state);
  const showNotificationGreetingSection = useSelector((state)=> state?.userdata?.showNotificationGreetingSection)
  const selectedMsisdn = useSelector(
    (state) => state.userdata.value.selectedmsisdn
  );
  const { CT_UserProfilePlan} = CT_Events();
  const {
    userdata: { dashboardRecommendations },
  } = useSelector((state) => state);
  const GTMLoginFlag = useSelector((state) => state.userdata.value.GTMLoginFlag);
  const GTMSingUPFlag = useSelector((state) => state.userdata.value.GTMSingUPFlag);
  const isWifiLogin = useSelector((state) => state.userdata.value.isWifiCase);
  const GTMWifiLoginFlag = useSelector((state) => state.userdata.value.GTMWifiLoginFlag)
  const [show, setShow] = React.useState();
  const [srvList, setSrvList] = React.useState([]); 
  const [showFooter, setShowFooter] = useState(false);
  const [srvbundle, setsrvbundle] = useState({});
  const flag = useContext(UserContext);
  const notificationsArray = useSelector((state) => state?.userdata?.notificationsArray);
  const showNotification = useSelector((state) => state?.userdata?.notificationAlert);
  const [viewPacksFlag, setViewPacksFlag] = useState(false);
  const language = getItemOfSessionStorage(SELECTED_LANG);
  const [viewPacksList, setViewPacksList] = useState()
  const [viewPacksMetaData, setViewPacksMetaData] = useState();
  const isDefaultCarouselBanner = useSelector((state) => state?.userdata?.isDefaultCarouselBanner);
  const [segmentationType, setSegmentationtype] = useState('');
  const {
    utilityData: { globalSetting },
  } = useSelector((state) => state);
  const settingsArr = globalSetting
    ? globalSetting?.Globalsettings[0]?.items[0]?.metadata
  : [];
  console.log("notification array---------------", notificationsArray);


  const redirectClick = (_url) => {
    redirecturl(_url, navigate);
};

  const dashboardApi = useQuery(
    [
      GetCacheKey("HOME_DASHBOARD_URL"),
      HOME_DASHBOARD_URL.url,
      HOME_DASHBOARD_URL.data,
      {},
    ],
    {
      retry: false,
      retryOnMount: true,
     onSuccess: ({data: resData}) => {
      dispatch(setpassportlist(resData?.response?.passportList))
       try{
          setItemInSessionStorage("c_net", JSON.stringify({planid:resData?.response?.coremynet?.offerId, planname: resData?.response?.coremynet?.title }))
          dispatch(setNewUserProperties({type:"Plan ID", data: resData?.response?.coremynet?.offerId}));
          dispatch(setNewUserProperties({type:"Plan Name", data: resData?.response?.coremynet?.title}));
       }catch{}
        if(!dashboardRecommendations){
          dispatch(setDashboardRecommendations(resData?.response?.recommendations));
        }
        try{
          try{
            CT_UserProfilePlan(resData?.message);
          }catch{}
          if(isWifiLogin && GTMWifiLoginFlag){
            dispatch(setLoginType("wifi"))
            GTM_Login("Dashboard", loginmsisdn, "wifi", socialLoginType);
            dispatch(setGTMWifiLoginFlag(false))
          }
          if(flag === "true"){
            GTM_Change_Msisdn("Dashboard", customerprofile?.Msisdn, customerprofile?.CustomerID, logintype, "Success");
          }
          if(GTMLoginFlag){
            GTM_Login("Dashboard", loginmsisdn, logintype, socialLoginType);
            dispatch(setGTMLoginFlag(false))
          }
          if(GTMSingUPFlag && !GTMLoginFlag ){
            GTM_SignUp("signup-email",loginmsisdn, logintype, socialLoginType);
            dispatch(setGTMSingUPFlag(false));
          } 
          if(getItemOfSessionStorage("pacilogin") === "true"){
            dispatch(setLoginType("paci"));
            GTM_Login("Dashboard", loginmsisdn, "paci", "");
          }
        }catch{}
        try{
          if(resData?.salert ){
            let alert_data = {
              button:resData?.salert?.title,
              desc: resData?.salert?.alert,
              external: resData?.salert?.external,
              img: "",
              notificationtype: resData?.salert?.alerttype,
              redirect: resData?.salert?.url,
              title:  resData?.salert?.popuptitle
            };
            dispatch(setNotificationsArray({type: "dashboardalert",data: alert_data}));
          }
        }catch{}
      }
    }
  );
  //view packs
  const viewPacks = useQuery([GetCacheKey("dashboard-viewPacks"), "/v6/api/pms/getdynamiccards", {type: 'rndashboardsegmentation'}, {}] );

  useEffect(()=>{
  if(viewPacks?.data?.data?.response && viewPacks?.data?.data?.response?.dynamictypes[0]?.cards){
    const metaDataList = viewPacks?.data?.data?.response?.dynamictypes[0]?.cards[0]?.metadata;
    setViewPacksList(viewPacks?.data?.data?.response?.dynamictypes[0]?.cards[0]);
    setViewPacksMetaData(metaDataList);
    metaDataList?.map(item => item?.meta_key === "isenable" ? language === 'ar'? setViewPacksFlag(item?.meta_value_arabic) : setViewPacksFlag(item?.meta_value_english): '');
    metaDataList?.map(item => item?.meta_key === "segmentationtype" ? language === 'ar'? setSegmentationtype(item?.meta_value_arabic) : setSegmentationtype(item?.meta_value_english): '');
  }
  }, [viewPacks?.isSuccess])
    const balanceApi = useQuery(
    customerprofile?.RatePlanType != null
      ? customerprofile?.RatePlanType === "POSTPAID"
        ? [
            balancekey,
            "/v6/api/billdetails/postpaid",
            { includeocc: "false" },
            {},
          ]
        : [balancekey, "/v6/api/balance/prepaid", {}, {}]
      : [],
    {
      retry: 1,
      retryOnMount: true,
      cacheTime: 0,
      staleTime: 0,
      // suspense: true,
      onSuccess: ({data: billDetails}) =>{
        try{
          if(billDetails?.salert ){
            let alert_data = {
              button:billDetails?.salert?.title,
              desc: billDetails?.salert?.alert,
              external: billDetails?.salert?.external,
              img: billDetails?.salert?.img,
              notificationtype: billDetails?.salert?.alerttype,
              redirect: billDetails?.salert?.url,
              title:  billDetails?.salert?.popuptitle
            };
            dispatch(setNotificationsArray({type: "dashboardalert",data: alert_data}));
          }
        }catch{}
      },
      enabled: customerprofile?.RatePlanType != null ? true : false,
    }
  );
  useEffect(() => {
    if (dashboardApi.isSuccess && dashboardApi?.data?.data) {
      // console.log(TransFormDashboard(dashboardApi?.data?.data));
      // setSrvList(TransFormDashboard(dashboardApi?.data?.data));
      
      //data format update for updated usage list view
      setSrvList(TransFormDashboardData(dashboardApi?.data?.data));
    }
  }, [dashboardApi?.data?.data, dashboardApi.isSuccess]);

  useEffect(() => {
    const data = balanceApi?.data?.data?.response;
    try{
    if (customerprofile?.RatePlanType === "POSTPAID")
      dispatch(setdueamount(balanceApi?.data?.data?.response?.dueamount));
    }
    catch(e){console.log("dueamount set error:"+e+"")}
    setsrvbundle(balanceApi?.data?.data?.response);
  }, [balanceApi?.data?.data, dashboardApi?.data?.data, customerprofile]);
  useEffect(() => {
    if (customerprofile) {
      if (
        customerprofile?.CustomerType === "B2B" &&
        customerprofile?.PaymentResponsible === ""
      ) {
        setShowFooter(false);
      } else {
        setShowFooter(true);
      }
      if (customerprofile?.RatePlanType === "POSTPAID") {
      } else {
      }
    }
  }, [customerprofile]);

  useEffect(()=>{
    if(!dashboardApi.isLoading){
      try{
        GTMScreenView("Dashboard", loginmsisdn, logintype)
      }catch{}
    }
  },[dashboardApi.isLoading]);

  


  return dashboardApi?.isLoading || dashboardApi?.isFetching || balanceApi?.isLoading ? (
    // <Loadingcomponent />
    /*
      conditions  
      when theme - 'mar-t200'
      when notifications - 'pt-70 mt-5'
      when no notifications - 'pt-30'
      showNotificationAndProfile
      notificationsArray?.length > 0
    */
    <div className={`${(!showNotificationAndProfile) ? 'mar-t200' : notificationsArray?.length > 0 ? 'pt-70 mt-5' : 'pt-30'}`}>
      <div class="swiper-container dashboard_swiper mb-3">
      <div class="swiper-wrapper">
          <div class="swiper-slide">
              <div class="white_card dashboard_card dls13_dashboard_card">
                  {/* <h3 class="primary_16 text-center mb-3 shimmerBG shimmer-card-title w-50 m-auto"></h3> */}
                  <div class="flex_grp_between dashboard_account">
                      <div class="dashboard_account_info w-100">
                          <div class="mobile_number text-ellipsis shimmerBG shimmer-p-text w-50 mb-2"></div>
                          <div class="mobile_number text-ellipsis shimmerBG shimmer-p-text w-50 mb-2"></div>
                          <div class="flex_grp_align_center flex-wrap d-flex">
                              <h5 class="primary_14 pack_name shimmerBG shimmer-p-text w-100 mb-2"></h5>
                          </div>
                      </div>
                      <div class="balance_section_action">
                          <button class="custom_btn custom_btn_sm shimmerBG shimmer-button-md"></button>
                      </div>
                  </div>
                  <div class="sprint14_dashboard_usage mb-3">
                      <div class="usage_list">
                          {/* <div class="usage_box">
                              <div class="usage_box_slider shimmerBG shimmer-icon-sm">
                              </div>
                              <div class="usage_box_info w-100 mt-0">
                                  <div class="usage_value shimmerBG shimmer-p-text p-2"></div>
                                  <div class="usage_label shimmerBG shimmer-p-text p-2"></div>
                              </div>
                          </div>
                          <div class="usage_box">
                              <div class="usage_box_slider shimmerBG shimmer-icon-sm">
                              </div>
                              <div class="usage_box_info w-100 mt-0">
                                  <div class="usage_valuee shimmerBG shimmer-p-text p-2"></div>
                                  <div class="usage_labele shimmerBG shimmer-p-text p-2"> </div>
                              </div>
                          </div>
                          <div class="usage_box">
                              <div class="usage_box_slider shimmerBG shimmer-icon-sm">
                              </div>
                              <div class="usage_box_info w-100 mt-0">
                                  <div class="usage_valuee shimmerBG shimmer-p-text p-2"></div>
                                  <div class="usage_labele shimmerBG shimmer-p-text p-2"> </div>
                              </div>
                          </div> */}

                          <div class="usage_list_2col w-100">
                              <div class="usage_box w-100">
                                <div class="usage_box_info">
                                  <div class="usage_value  shimmerBG shimmer-p-text p-2 mb-1 w-75"></div>
                                  <div class="usage_label shimmerBG shimmer-p-text p-2 w-50"><span>  </span></div>
                                </div>
                                  <div class="usage_box_slider shimmerBG shimmer-p-text height-10">
                                  </div>
                              </div>

                              <div class="vr-sm shimmer-border-color"></div>

                              <div class="usage_box w-100">
                                <div class="usage_box_info">
                                  <div class="usage_value  shimmerBG shimmer-p-text p-2 mb-1 w-75"></div>
                                  <div class="usage_label shimmerBG shimmer-p-text p-2 w-50"><span>  </span></div>
                                </div>
                                  <div class="usage_box_slider shimmerBG shimmer-p-text height-10">
                                  </div>
                              </div>
                          </div>
                      </div>

                      {/* <div class="flex_grp_center">
                          <button class="usage_more_btn shimmerBG shimmer-icon-xs" id="usage_more_btn">
                          </button>
                      </div> */}
                  </div>
                  <div className="balance_section">
                  <div class="flex_grp_center">
                          <button class="usage_more_btn shimmerBG shimmer-icon-xs" id="usage_more_btn">
                          </button>
                      </div>
                  <div class="flex_grp_between">
                      <div class="balance_section_info w-100">
                          <label class="shimmerBG shimmer-p-text p-2 w-25"></label>
                          <h3 class="balance shimmerBG shimmer-p-text p-3 w-50"></h3>
                          <div class="dls13-paybefore shimmerBG shimmer-p-text p-1 w-75"></div>
                      </div>
                      <div class="balance_section_action">
                          <button class="custom_btn custom_btn_sm custom_btn_primary shimmerBG shimmer-button-md"></button>
                      </div>
                  </div>
                  </div>
              </div>
          </div>
      </div>
      <div class="swiper-pagination"></div>
      </div>
    </div>
  ) : srvList.length ? (
    <div className={`mb-3 ${ showNotificationGreetingSection ? notificationsArray?.length > 0 ?  'pt-70 mt-5': 'pt-30' : 'mar-t200'}`}>
      <Swiper
        modules={[Pagination]}
        className="dashboard_swiper"
        spaceBetween={12}
        slidesPerView={1}
        pagination={{
          clickable: true
        }}
        onSlideChange={() => {
          setShow(false);
        }}
      >
        {srvList.map((item, index) => {
          const itemsList = generateDashboardLayout(item?.balancelist);
          return(
          <SwiperSlide>
            <div className="white_card dashboard_card dls13_dashboard_card ">
              {/* <h3 className="primary_16 text-center mb-3">{t("overview")}</h3> */}
              <div className="mt-2">
                <div className="dashboard_account_info">
                <div className="primary_14 mb-0 user_name">
               {
                //  !showNotificationGreetingSection &&
                  `${getGlobalSettingValue('nicknameprefixlabel', settingsArr)}${userDetails?.nickname ? " " +userDetails?.nickname + "," : ","  }`}
                </div>
                <div className="d-flex justify-content-between">
                    <div className="mobile_number">
                      {/* {GetMobileNo(customerprofile?.Msisdn)} */}
                      {selectedMsisdn}
                    </div>
                    <div className="dashboard_account_action">
                      <button
                        className="custom_btn custom_btn_sm custom_btn_primary_outline text-initials"
                        onClick={() => navigate("/manage-account")}
                      >
                        {t('dashboardmanage')}
                      </button>
                  </div>
                </div>
                  <div className="flex_grp_align_center flex-wrap">
                    <h5 className="primary_14 pack_name mb-0" style={{"direction":isContainAlphabet(item?.title) ? "ltr" :""}}
                    >{item?.title}</h5>
                    {item?.showcommitmentenddate == "T" ? (
                      <p className="duration mb-0">/ {` ${item?.commitmentenddate}`}</p>
                    ) : (
                      <p className="duration mb-0">
                       / {` ${item?.days } ${t("days")} `} 
                      </p>
                    )}
                  </div>
                </div>
              </div>
              {/* className="dashboard_usage" */}
             

              <div class="hr-sm"></div>
              <div 
              className={`sprint14_dashboard_usage ${(srvbundle?.status_en == 'suspended' ||
              srvbundle?.status_en == 'barred' || srvbundle?.status_en == 'linexpiry')
              && (customerprofile.BarringStatus != 'PBA')  ?
               'sprint14-alert-message position-relative':''}`}>
                {
                srvbundle?.status_en == 'suspended' ||
                srvbundle?.status_en == 'barred' ? (<>
                {customerprofile.BarringStatus == 'PBA' &&
                getGlobalSettingValue('allowbarredpbadashboard', settingsArr) ==
                'T' ? null :(<>
                {
                srvbundle?.status_en == 'suspended' ? (<>
                {/* <div className="balance_section">
                    <div className="dflex-row">
                        <h5>{srvbundle?.status_title }</h5>
                        <Lottie animationData={lock} loop={true}
                                style={{width: "20px", height: '20px'}} />
                    </div>
                    <p>{srvbundle?.status_desc}</p>
                </div> */}

                <div class={`alert-message-comp ${item?.balancelist?.length > 2 ? 'sprint14-h130':''}`}>
                   <div class="suspended svg_50">
                   {/* <lottie-player src={lock}
                    background="transparent" speed="1" style="width: 50px; height: 50px;"
                     class="me-1" loop autoplay></lottie-player>  */}
                      <Lottie animationData={lock} loop={true} />
                   {srvbundle?.status_title}
                   {srvbundle?.status_desc}
                    </div>                                                    
                  </div>

                </>):
                srvbundle?.status_en == 'barred' ? (<>
                <div class={`alert-message-comp ${item?.balancelist?.length > 2 ? 'sprint14-h130':''}`}>
                   <div class="suspended svg_50">
                  <Lottie animationData={yellowlock} loop={true} />
                  {srvbundle?.status_title}
                   {srvbundle?.status_desc}
                    </div>                                                    
                  </div>

                </>) : (<></>)
                }
                </>)
                }
                </>):(<></>)
                }

                {
                  srvbundle?.status_en != 'linexpiry' ? (<>
                  <div className={`usage_list ${show ? "expand" : ""}`}>
                  {/* old usage view */}
                  {/* {item?.balancelist?.map((item2, index) => (
                    <div className="usage_box">
                      <div className="usage_box_slider">
                        <ChangingProgressProvider
                          values={[
                            0,
                            item2?.isunlimited
                              ? (item2?.rnlabel?.length > 0 ? (item2.total != 0 ?  (parseInt(item2.balance) /parseInt(item2.total)) *100 : 0 ): 100)
                              : (item2?.total != 0 ? (parseInt(item2.balance) /
                                  parseInt(item2.total)) *
                                100 : 0),
                          ]}
                        >
                          {(value) => (
                            <CircularProgressbar
                              value={value}
                              text={`${value}%`}
                              circleRatio={0.5}
                              // className="blue_semicircle"
                              styles={buildStyles({
                                rotation: 1 / 2 + 1 / 4,
                                strokeLinecap: "round",
                                trailColor: "#EEEEEE",
                                pathColor: item2.color,
                              })}
                            />
                          )}
                        </ChangingProgressProvider>
                      </div>
                      <div className="usage_box_info">
                        <div className="usage_value">
                          {item2.isunlimited ? 
                          item2?.rnlabel?.length >0 ? (Math.round((item2?.cbalance) * 100) / 100):
                          (
                            <img
                              src={
                                item2?.color.toLowerCase() === "#99cc00"
                                  ? process.env.PUBLIC_URL +
                                    "/assets/images/infinite_green.svg"
                                  : item2.color.toLowerCase() === "#59c0ed"
                                  ? process.env.PUBLIC_URL +
                                    "/assets/images/infinite_blue.svg"
                                  : process.env.PUBLIC_URL +
                                    "/assets/images/infinite_orange.svg"
                              }
                              alt=""
                              title=""
                            />
                          ) : (
                            (Math.round((item2?.cbalance) * 100) / 100)
                          )}
                        </div>
                        <div className="usage_label">{item2.notation}</div>
                        <div className="usage_label">
                        {item2?.rnlabel?.length >0 &&
                        <div >
                          {item2?.rnlabel}
                          {item2?.isunlimited &&
                          <svg class="ms-1" xmlns="http://www.w3.org/2000/svg" width="21.383" height="10.104" viewBox="0 0 21.383 10.104">
                          <path id="Path" d="M16.37,0a5.052,5.052,0,0,1,0,10.1c-2.432,0-3.851-1.21-6.138-4.4L10.08,5.5c-2.167-3.026-3.22-3.98-5.067-3.98a3.537,3.537,0,0,0,0,7.073A4.331,4.331,0,0,0,7.836,7.4.751.751,0,0,1,8.9,7.487a.76.76,0,0,1-.084,1.066,5.792,5.792,0,0,1-3.8,1.551,5.052,5.052,0,0,1,0-10.1c2.432,0,3.851,1.21,6.138,4.4l.152.212c2.167,3.026,3.22,3.98,5.067,3.98a3.537,3.537,0,0,0,0-7.073A4.331,4.331,0,0,0,13.547,2.7a.751.751,0,0,1-1.064-.085.76.76,0,0,1,.084-1.066A5.792,5.792,0,0,1,16.37,0Z" fill="#ccc"></path>
                          </svg>
                          }
                        </div>
                        }
                        </div>
                      </div>
                    </div>
                  ))} */}

                  {/* was commented - not required */}
                  {/* <div className="usage_box">
                    <div className="usage_box_slider">
                      <ChangingProgressProvider values={[0, 100]}>
                        {(value) => (
                          <CircularProgressbar
                            value={value}
                            text={`${value}%`}
                            circleRatio={0.5}
                            className="green_semicircle"
                            styles={buildStyles({
                              rotation: 1 / 2 + 1 / 4,
                              strokeLinecap: "round",
                              trailColor: "#EEEEEE",
                            })}
                          />
                        )}
                      </ChangingProgressProvider>
                    </div>
                    <div className="usage_box_info">
                      <div className="usage_value">
                        <img
                          src={
                            process.env.PUBLIC_URL +
                            "/assets/images/infinite_green.svg"
                          }
                          alt=""
                          title=""
                        />
                      </div>
                      <div className="usage_label">Roaming Intl Data</div>
                    </div>
                  </div>
                  <div className="usage_box">
                    <div className="usage_box_slider">
                      <ChangingProgressProvider values={[0, 100]}>
                        {(value) => (
                          <CircularProgressbar
                            value={value}
                            text={`${value}%`}
                            circleRatio={0.5}
                            className="orange_semicircle"
                            styles={buildStyles({
                              rotation: 1 / 2 + 1 / 4,
                              strokeLinecap: "round",
                              trailColor: "#EEEEEE",
                            })}
                          />
                        )}
                      </ChangingProgressProvider>
                    </div>
                    <div className="usage_box_info">
                      <div className="usage_value">
                        <img
                          src={
                            process.env.PUBLIC_URL +
                            "/assets/images/infinite_orange.svg"
                          }
                          alt=""
                          title=""
                        />
                      </div>
                      <div className="usage_label">Unlimited SMS</div>
                    </div>
                  </div> */}
                  
                  {/* new usage view */}
                  {
                   
                    itemsList?.map((listItem, index) => {
                      return <UsageList key={`index_${index}`} listItem={listItem} count={itemsList?.length} />
                    })
                  }
                  </div>

                {/* was commented - not required */}
                {/* Open when usage details not found */}
                {/* <div className="empty_dashboard flex_grp_center">
                  <img src={process.env.PUBLIC_URL +  "/assets/images/empty_dashboard.png"} alt="" title="" />
                </div> */}

                {item?.balancelist?.length > 2 && (
                  <div className="flex_grp_center">
                    <button
                      onClick={() => setShow(!show)}
                      className={`usage_more_btn ${show ? "open" : ""}`}
                    >
                      {/* <img
                        src={
                          process.env.PUBLIC_URL +
                          "/assets/images/arrow_down_dark_sm.svg"
                        }
                        alt=""
                        title=""
                      /> */}
                   {
                      show ? <> 
                      <Lottie animationData={dropdownup} loop={true} 
                         />
                     </>:<>
                     <Lottie animationData={dropdown} loop={true} 
                      />
                      </>

                   }
                 

                    </button>
                  </div>
                )}
                
                </>):(<>
                </>)
                }

               </div>

                {/* below block is to show lineexpiry case */}
                {
                srvbundle?.status_en == 'linexpiry' ? (<>
                <div class="hr-sm"></div>
                <div class="sprint14-dashbord-comp" style={{marginTop: item?.balancelist?.length > 2 ? '' : '-22px'}}>
                    <div className="dflex-row">
                        <h5>{srvbundle?.status_title }</h5>
                        <Lottie animationData={lineexpirylotte} loop={true} 
                        style={{width: "25px", paddingBottom: '10px'}} />
                    </div>

                    <p>{srvbundle?.status_desc}</p>
                    <Link className="hyperlink" style={{marginTop:"6px"}}
                           onClick={()=>redirectClick(srvbundle?.status_btnurl)}>
                    {srvbundle?.status_btntext}
                    <img src={process.env.PUBLIC_URL + '/assets/images/right_arrow_red.svg' } alt="" title="" />
                    </Link>
                </div>
                </>):(<></>)
                }


              {viewPacksFlag === 'T' && viewPacksList !== null && viewPacksList !== undefined ?
              <>
              
              {/* <div class="hr-sm"></div>         */}
              
            
               <div class="sprint14-dashbord-comp" style={{marginTop: item?.balancelist?.length > 2 ? '' : '-22px'}}>
                  <div class={`dflex-row ${segmentationType?.toLowerCase() === "roaming" ? '' : 'mb-2'}`}>
                    <h5> {viewPacksList?.displaytext } </h5>
                    {segmentationType?.toLowerCase() === "roaming" && <Lottie  
                      animationData={loader}
                      // src="assets/images/sprint14/animations/Flight.json"
                      background="transparent"
                      speed="1" style={{width: "47px", height: "47px"}}
                      loop autoplay>
                    </Lottie>}
                  </div>
                  <p>{viewPacksList?.description}</p>
                  <Link className="hyperlink" style={{marginTop:"6px"}}
                    to={`/${viewPacksMetaData?.filter(item => item?.meta_key === "web_redirection")[0]?.[language=== 'ar'? 'meta_value_arabic': 'meta_value_english']}`}>
                    {viewPacksList?.buttontext}
                    <img src={process.env.PUBLIC_URL + '/assets/images/right_arrow_red.svg'} class="ms-1" alt="" title="" />
                  </Link>
                </div>
              </>
                
              :''}
              {showFooter && (
                <>
                {
                  viewPacksFlag === 'T' && (
                    <div class="hr-sm"></div>
                  )
                }
                 
                 <div className="flex_grp_between">
                  <div className="balance_section_info">
                    <label>
                      {customerprofile?.RatePlanType === "POSTPAID"
                        ? t("dueamount")
                        : t("balance")}
                    </label>
                    <h3 className="balance">
                      {srvbundle != null &&
                      srvbundle?.currency != null &&
                      srvbundle?.currency != undefined &&
                      customerprofile.RatePlanType === "POSTPAID"
                        ? (srvbundle?.currency || "") +
                          " " +
                          (srvbundle?.dueamount || "0.00")
                        : (srvbundle?.currency || "") +
                          " " +
                          (srvbundle?.totalbalance || "0.00")}
                    </h3>

                                        {customerprofile.RatePlanType === "POSTPAID" && (srvbundle?.dueamount && parseFloat(srvbundle?.dueamount)) > 0  ?
                        <div className="dls13-paybefore">{`${srvbundle?.rnlabel} 
                        ${srvbundle?.rnlastbillrundate}`}</div>
                    : ""}
                    {customerprofile.RatePlanType === "POSTPAID" ? (
                    <div>                   
                      <Link
                        // to="/viewbill"
                        to="/your-bill"
                        className="custom_btn custom_btn_sm custom_btn_primary_outline mt-3"
                      >
                        {t("viewbill")}
                      </Link>
                      </div>) : (
                      // null
                      <>
                      {
                        srvbundle?.totalbalance > 0 && !srvbundle?.rnexpirydate?.includes('--T') && (
                          <p className="mb-0">
                            {t("expireson")} {srvbundle?.rnexpirydate}
                          </p>
                        )
                      }
                      </>
                    )}
                  </div>
                  <div class={`balance_section_action ${customerprofile.RatePlanType === "POSTPAID" ? "" : 'align-self-center'}`}
                  >
                    <Link
                      to="/recharge"
                      className="custom_btn custom_btn_sm custom_btn_primary"
                    >
                      {customerprofile?.RatePlanType === "POSTPAID"
                        ? t("paynow")
                        : t("recharge")}
                    </Link>
                  </div>
                </div>
                
                </>
               
              )}
            </div>
          </SwiperSlide>
        )})}
      </Swiper>
    </div>

  

  ) : (
    <div className={`mb-3 ${ showNotificationGreetingSection ? notificationsArray?.length > 0 ?  'pt-70': 'pt-30' : 'mar-t200'}`}>
    <Swiper
        modules={[Pagination]}
        className="dashboard_swiper"
        spaceBetween={12}
        slidesPerView={1}
        pagination={{
          clickable: true
        }}
      >
      <SwiperSlide>
      <div className="white_card dashboard_card dls13_dashboard_card">
        {/* <h3 className="primary_16 text-center mb-3">{t("overview")}</h3> */}
        <div className="mt-2">
          <div className="dashboard_account_info">
          <div className="primary_14 mb-0 user_name">
              {
                //  !showNotificationGreetingSection &&
                  `${getGlobalSettingValue('nicknameprefixlabel', settingsArr)}${userDetails?.nickname ? " " +userDetails?.nickname + "," : ","  }`}
            </div>
            <div className="d-flex justify-content-between">
              <div className="mobile_number">
                {/* {GetMobileNo(customerprofile?.Msisdn)} */}
                {selectedMsisdn}
                </div>
                <div className="dashboard_account_action">
                  <button
                    className="custom_btn custom_btn_sm custom_btn_primary_outline"
                    onClick={() => navigate("/manage-account")}
                  >
                    {t("dashboardmanage")}
                  </button>
                </div>
            </div>
            <div className="flex_grp_align_center flex-wrap">
              <label className="primary_14 mb-0 user_name">{t("noactpacks")}</label>
            </div>
          </div>
        </div>     
       
              <div class="hr-sm"></div>
             
              <div 
              className={`sprint14_dashboard_usage ${(srvbundle?.status_en == 'suspended' ||
              srvbundle?.status_en == 'barred' || srvbundle?.status_en == 'linexpiry')
              && (customerprofile.BarringStatus != 'PBA')
              ? 'sprint14-alert-message position-relative':''}`}>
                
                {
                srvbundle?.status_en == 'suspended' ||
                srvbundle?.status_en == 'barred' ? (<>
                {customerprofile.BarringStatus == 'PBA' &&
                getGlobalSettingValue('allowbarredpbadashboard', settingsArr) ==
                'T' ? null :(<>
                {
                srvbundle?.status_en == 'suspended' ? (<>
                 <div class="alert-message-comp">
                   <div class="suspended">
                  <Lottie animationData={lock} loop={true}
                                style={{width: "50px", height: '50px'}} />
                   {srvbundle?.status_title}
                   {srvbundle?.status_desc}
                    </div>                                                    
                  </div>
                </>):
                srvbundle?.status_en == 'barred' ? (<>
                <div class="alert-message-comp">
                   <div class="suspended">
                  <Lottie animationData={yellowlock} loop={true}
                  style={{width: "50px", height: '50px'}} />
                  {srvbundle?.status_title}
                   {srvbundle?.status_desc}
                    </div>                                                    
                  </div>
                </>) : (<></>)
                }
                </>)
                }
                </>):(<></>)
                }
                {
                  srvbundle?.status_en != 'linexpiry' ? (<>
                  <div className="dashboard_usage">
                  <div className="usage_list nodata-comp">
                   <img
                      src={
                      process.env.PUBLIC_URL + "/assets/images/empty_dashboard.png"
                     }
                     alt=""
                    title=""
                     />
                  </div>
                 </div>
                </>):(<>
                </>)
                }

               </div>

              {/* below block is to show lineexpiry case */}
                {
                srvbundle?.status_en == 'linexpiry' ? (<>
                <div class="sprint14-dashbord-comp">
                    <div className="dflex-row">
                        <h5>{srvbundle?.status_title }</h5>
                        <Lottie animationData={lineexpirylotte} loop={true} 
                        style={{width: "25px", paddingBottom: '10px'}} />
                    </div>

                    <p>{srvbundle?.status_desc}</p>
                    <Link className="hyperlink" style={{marginTop:"6px"}}
                          onClick={() =>redirectClick(srvbundle?.status_btnurl)}>
                    {srvbundle?.status_btntext}
                    <img src={process.env.PUBLIC_URL + '/assets/images/right_arrow_red.svg' } alt="" title="" />
                    </Link>
                </div>
                </>):(<></>)
                }


              {viewPacksFlag === 'T' && viewPacksList !== null && viewPacksList !== undefined ?
              <>
               <div class="hr-sm"></div>
                <div class="sprint14-dashbord-comp">
                  <div class={`dflex-row ${segmentationType?.toLowerCase() === "roaming" ? '' : 'mb-2'}`}>
                    <h5> {viewPacksList?.displaytext } </h5>
                    {segmentationType?.toLowerCase() === "roaming" && <Lottie  
                      animationData={loader}
                      // src="assets/images/sprint14/animations/Flight.json"
                      background="transparent"
                      speed="1" style={{width: "47px", height: "47px"}}
                      loop autoplay>
                    </Lottie>}
                  </div>
                  <p>{viewPacksList?.description}</p>
                  <Link className="hyperlink" style={{marginTop:"6px"}}
                    to={`/${viewPacksMetaData?.filter(item => item?.meta_key === "web_redirection")[0]?.[language=== 'ar'? 'meta_value_arabic': 'meta_value_english']}`}>
                    {viewPacksList?.buttontext}
                    <img src={process.env.PUBLIC_URL + '/assets/images/right_arrow_red.svg'} class="ms-1" alt="" title="" />
                  </Link>
                </div>
              </>
              :''}


        {showFooter && (
          // <div className="flex_grp_between balance_section">
          //   <div className="balance_section_info">
          //     <label>
          //       {customerprofile?.RatePlanType === "POSTPAID"
          //         ? t("dueamount")
          //         : t("balance")}
          //     </label>
          //     <h3 className="balance">
          //       {srvbundle != null &&
          //       srvbundle?.currency != null &&
          //       srvbundle?.currency != undefined &&
          //       customerprofile.RatePlanType === "POSTPAID"
          //         ? (srvbundle?.currency || "KD") +
          //           " " +
          //           (srvbundle?.dueamount || "0.00")
          //         : (srvbundle?.currency || "KD") +
          //           " " +
          //           (srvbundle?.totalbalance || "0.00")}
          //     </h3>
          //   </div>
          //   <div className="balance_section_action">
          //     <Link
          //       to="/recharge"
          //       className="custom_btn custom_btn_sm custom_btn_primary"
          //     >
          //       {customerprofile?.RatePlanType === "POSTPAID"
          //         ? t("paynow")
          //         : t("recharge")}
          //     </Link>
          //   </div>
          // </div>

          <div className="flex_grp_between balance_section">
          <div className="balance_section_info">
            <label>
              {customerprofile?.RatePlanType === "POSTPAID"
                ? t("dueamount")
                : t("balance")}
            </label>
            <h3 className="balance">
              {srvbundle != null &&
              srvbundle?.currency != null &&
              srvbundle?.currency != undefined &&
              customerprofile.RatePlanType === "POSTPAID"
                ? (srvbundle?.currency || "") +
                  " " +
                  (srvbundle?.dueamount || "0.00")
                : (srvbundle?.currency || "") +
                  " " +
                  (srvbundle?.totalbalance || "0.00")}
            </h3>
            
            {customerprofile.RatePlanType === "POSTPAID" 
            && (srvbundle?.dueamount && parseFloat(srvbundle?.dueamount)) > 0 ?
                <div className="dls13-paybefore">{`${srvbundle?.rnlabel} 
                ${srvbundle?.rnlastbillrundate}`}</div>
            : ""} 
            {customerprofile.RatePlanType === "POSTPAID" ? (
            <div>                   
              <Link
                // to="/viewbill"
                to="/your-bill"
                className="custom_btn custom_btn_sm custom_btn_primary_outline mt-3"
              >
                {t("viewbill")}
              </Link>
              </div>) : (
              // null
              <>
                {
                  srvbundle?.totalbalance > 0 && !srvbundle?.rnexpirydate?.includes('--T') && (
                    <p className="mb-0">
                      {t("expireson")} {srvbundle?.rnexpirydate}
                    </p>
                  )
                }
              </>
            )}
          </div>
          <div className={`balance_section_action ${customerprofile.RatePlanType === "POSTPAID" ? "" : 'align-self-center'}`}>
            <Link
              to="/recharge"
              className="custom_btn custom_btn_sm custom_btn_primary"
            >
              {customerprofile?.RatePlanType === "POSTPAID"
                ? t("paynow")
                : t("recharge")}
            </Link>
          </div>
        </div>
        )}
      </div>
      </SwiperSlide>
      </Swiper>
    </div>
  );
};
export default DashboardComponent;
